import React from 'react'
import { Redirect } from 'react-router-dom'

import dashboardRoutes from './views/dashboard/DashboardRoutes'
import pagesRoutes from './views/pages/pagesRoutes'
import adminRoutes from './views/admin/adminRoutes'

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/dashboard" />,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/404" />,
    },
]

const routes = [
    ...dashboardRoutes,
    ...pagesRoutes,
    ...adminRoutes,
    ...redirectRoute,
    ...errorRoute,
]

export default routes
